var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgSuccessModal({
  title,
  titleId,
  ...props
}, svgRef) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 48,
    height: 48,
    viewBox: "0 0 24 25",
    fill: "#327E38",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M11.3906 16.5439C10.875 17.0596 10.0781 17.0596 9.5625 16.5439L6.5625 13.5439C6.04688 13.0283 6.04688 12.2314 6.5625 11.7158C7.07812 11.2002 7.875 11.2002 8.39062 11.7158L10.5 13.7783L15.5625 8.71582C16.0781 8.2002 16.875 8.2002 17.3906 8.71582C17.9062 9.23145 17.9062 10.0283 17.3906 10.5439L11.3906 16.5439ZM24 12.6064C24 19.2627 18.6094 24.6064 12 24.6064C5.34375 24.6064 0 19.2627 0 12.6064C0 5.99707 5.34375 0.606445 12 0.606445C18.6094 0.606445 24 5.99707 24 12.6064ZM12 2.85645C6.60938 2.85645 2.25 7.2627 2.25 12.6064C2.25 17.9971 6.60938 22.3564 12 22.3564C17.3438 22.3564 21.75 17.9971 21.75 12.6064C21.75 7.2627 17.3438 2.85645 12 2.85645Z"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgSuccessModal);
export default __webpack_public_path__ + "static/media/SuccessModal.8db38fd6eb3877b233adb01c3da7e002.svg";
export { ForwardRef as ReactComponent };